const blogs = [
    {
        name: "Accomplishing the Full-Stack Web Development Certificate",
        date: "August 2022",
        des2: "University of Toronto",
        icon: "https://user-images.githubusercontent.com/95199209/188290860-0dbac05b-906f-409e-9837-9be4a8689ce7.jpg",
        description: 'Coding in JavaScript started to become a "second nature", just like another spoken language',
    },
    {
        name: "My certification path in AWS",
        date: "- Certified Cloud Practitioner: ✓",
        des2: "- Solution Architect Associate: In Progress",
        icon: "https://d1.awsstatic.com/training-and-certification/certification-badges/AWS-Certified-Cloud-Practitioner_badge.634f8a21af2e0e956ed8905a72366146ba22b74c.png",
        description: "The optimizations of application hosting and computing was always fun to learn, when it all boils down to cost savings and performance enhancements for a business.",
        link: "https://www.credly.com/badges/3bcf01a9-c1f1-40c7-a507-38556a06d8f4"
    },
    {
        name: "My Fitness and Powerlifting Journey",
        date: "",
        icon: "https://user-images.githubusercontent.com/95199209/190017750-4fadccdd-5413-42af-9e21-6e5e93840a1e.jpg",
        description: 'Placed 2nd in the 83kg weight class of "Strength in the Valley" Powerlifting Competition',
        link: "https://www.powerlifting.ca/lifter_database/external/contest_results.php?contest=DVP%20Strength%20In%20the%20Valley",
        location: "Hamilton, ON"
    },
    {
        name: "Becoming a developer has been my driving force to learn new technologies",
        date:"January 2022",
        icon: "https://user-images.githubusercontent.com/95199209/185305628-f47d323d-e3ad-420a-a101-706f3072b44b.png",
        description: "Starting out as a developer is challenging, but always fun. The dopamine rush from solving a mysterious bug was unbelievable",
        link: "https://github.com/hfang821"
    },
    {
        name: "Starting an new era with a business mindset",
        date:"September 2020",
        icon: "https://user-images.githubusercontent.com/95199209/185303350-1f01d437-881f-4f40-baed-c909b2d21e80.jpg",
        description: "Learning the financial and sustainable aspects of a business, I grew myself into solving problems over the big picture.",
        location: "Schulich School of Business"
    },
    {
        name: "I received my engineering ring!",
        date: "March 2019",
        icon: "https://user-images.githubusercontent.com/95199209/185302048-94efa377-fb1f-4aa9-b4c3-fece48a98c47.png",
        description: "Iron ring ceremony! After countless assignments, exams and all nighters, this celebration reminded me that the dedication and hard work has paid off.",
        location: "Western University"
    }
]

module.exports = blogs;